<template>
  <div v-if="this.currentUser">
    <b-card class="md-3" style="min-height:410px">

      <!-- Titulo de la seccion-->
      <b-row>
          <b-col class="align-left">
            <p>Editar usuario del sistema</p>
          </b-col>
      </b-row>

      <!-- Formulario de adicion de nodos -->
                <div id="formulario-usuarios" style="width:100%">
                  <div v-if="!submitted">

                      <!-- INIT FORMULARIO DE ADICION -->
                     <b-form @submit="updateUser" @reset="exitForm">
                      <div class="groupBox">
                            <!-- Fila 1 -->
                        <b-row>
                            <b-col>
                              <br />
                              <small
                                >Nota: El identificador único del usuario es su email, por lo <br />
                                que no podrá ser cambiado a posteriori excepto por un administrador
                              </small>                              
                            </b-col>
                            <!--spacer -->
                            <b-col class="col-sm-1 col-xs-3">
                            </b-col>
                            <!--spacer -->
                            <b-col>
                              <b-form-group  label-size="sm" label="Identificación fiscal (NIF/CIF) *" label-for="nif">
                                <b-form-input id="nif" name="nif" placeholder="..." v-model="currentUser.nif" :value="currentUser.nif" :disabled="disabledInput" required></b-form-input>
                              </b-form-group>
                            </b-col>
                        </b-row>

                        <!-- Fila 2 -->
                        <b-row>
                            <b-col>
                              <b-form-group  label-size="sm" label="Nombre del usuario *" label-for="name">
                                <b-form-input id="name" name="name" size="sm" placeholder="..." v-model="currentUser.name" :value="currentUser.name" :disabled="disabledInput" required></b-form-input>
                              </b-form-group>
                            </b-col>
                            <!--spacer -->
                            <b-col class="col-sm-1 col-xs-3">
                            </b-col>
                            <!--spacer -->
                            <b-col>
                              <b-form-group  label-size="sm" label="Dirección de la residencia habitual" label-for="address">
                                <b-form-input id="type" name="address" placeholder="..." v-model="currentUser.address" :value="currentUser.address" :disabled="disabledInput" ></b-form-input>
                              </b-form-group>
                            </b-col>
                        </b-row>

                        <!-- Fila 3 -->
                        <b-row>
                            <b-col>
                              <b-form-group label-size="sm" label="Apellidos del usuario *" label-for="surname">
                                <b-form-input id="surname" name="surname" size="sm" placeholder="..." v-model="currentUser.surname" :value="currentUser.surname" :disabled="disabledInput" required></b-form-input>
                              </b-form-group>
                            </b-col>
                            <!--spacer -->
                            <b-col class="col-sm-1 col-xs-3">
                            </b-col>
                            <!--spacer -->
                            <b-col>
                              <b-row>
                                <b-col>
                                  <b-form-group  label-size="sm" label="Ciudad" label-for="city">
                                    <b-form-input id="city" name="city" size="sm" placeholder="..." v-model="currentUser.city" :value="currentUser.city" :disabled="disabledInput"></b-form-input>
                                  </b-form-group>
                                </b-col>
                                  <b-col>
                                    <b-form-group  label-size="sm" label="Provincia" label-for="province">
                                      <b-form-input id="province" name="province" size="sm" placeholder="..." v-model="currentUser.province" :value="currentUser.province" :disabled="disabledInput"></b-form-input>
                                    </b-form-group>
                                  </b-col>
                                  <b-col>
                                  <b-form-group  label-size="sm" label="Código Postal" label-for="zip">
                                    <b-form-input type='number' onkeydown = "javascript: return event.keyCode === 8 ||
event.keyCode === 46 ? true : !isNaN(Number(event.key))" id="zip" name="zip" size="sm" placeholder="..." v-model="currentUser.zip" :value="currentUser.zip" :disabled="disabledInput"></b-form-input>
                                  </b-form-group>
                                </b-col>
                              </b-row>
                            </b-col>
                        </b-row>


                        <!-- Fila 3.1 -->
                        <b-row>
                          <b-col>
                            <b-form-group  label-size="sm" label="Email de contacto *" label-for="email">
                              <b-form-input id="email" name="email" size="sm" placeholder="...@..." v-model="currentUser.email" :value="currentUser.email" :disabled="disabledInput"></b-form-input>
                            </b-form-group>
                          </b-col>
                            <!--spacer -->
                            <b-col class="col-sm-1 col-xs-1">
                            </b-col>
                            <!--spacer -->
                            <b-col>
                              <b-form-group label-size="sm" label="Rol del usuario *" label-for="role">
                                <b-form-select id="role" name="role" v-model="selectedRole" style="cursor:pointer;" :disabled="disabledInput">
                                    <b-form-select-option value="null">No especificado</b-form-select-option>
                                    <b-form-select-option v-for="(role, index) in roleList" v-bind:key="index" v-bind:value="role">
                                      {{role}}
                                    </b-form-select-option>
                                </b-form-select>
                              </b-form-group>
                            </b-col>
                        </b-row>


                        <!-- Fila 3.2 -->
                        <b-row>
                          <b-col>
                            <b-form-group  label-size="sm" label="Telefono de contacto *" label-for="phone">
                              <b-form-input id="phone" name="surname" size="sm" placeholder="..." v-model="currentUser.phone" :value="currentUser.phone" :disabled="disabledInput" required></b-form-input>
                            </b-form-group>
                          </b-col>
                            <!--spacer -->
                            <b-col class="col-sm-1 col-xs-1">
                            </b-col>
                            <!--spacer -->
                            <b-col>
                              <b-form-group label-size="sm" label="Estado de la cuenta *" label-for="status">
                                <b-form-select id="status" name="status" v-model="currentUser.status" style="cursor:pointer;" :disabled="disabledInput">
                                  <b-form-select-option value="true">Cuenta activa</b-form-select-option>
                                  <b-form-select-option value="false">Cuenta inactiva</b-form-select-option>
                                </b-form-select>
                              </b-form-group>
                            </b-col>
                        </b-row>

                        <!-- Fila 4 -->
                        <b-row>
                            <b-col>
                              <b-form-group  label-size="sm" label="Contraseña de acceso **" label-for="password">
                                <b-form-input type="password" id="password" name="password" size="sm" placeholder="..." min="6" v-model="password" :disabled="disabledInput"></b-form-input>
                              </b-form-group>
                            </b-col>
                            <!--spacer -->
                            <b-col class="col-sm-1 col-xs-1">
                            </b-col>
                            <!--spacer -->
                            <b-col>
                              <b-form-group  label-size="sm" label="Repita la contraseña de acceso **" label-for="passwordcheck">
                                <b-form-input type="password" id="passwordcheck" size="sm" placeholder="..." min="6" v-model="passwordcheck" :disabled="disabledInput"></b-form-input>
                              </b-form-group>
                            </b-col>
                        </b-row>


                        <!-- Fila 6 -->
                        <b-row>
                            <b-col>
                              <small>* El campo debe ser rellenado</small><br>
                              <small>** La contraseña debe tener mínimo 6 caracteres (espacio en blanco no permitido)</small>
                            </b-col>
                            <!--spacer -->
                            <b-col class="col-sm-1 col-xs-1">
                            </b-col>
                            <!--spacer -->
                            <b-col>
                              <b-row>
                                <b-col>
                                  <b-form-group label-for="adduser">
                                    <b-button block type="submit" name="adduser" id="adduser" variant="primary">
                                      <i class="fas fa-edit"></i>
                                      <span class="text-uppercase" style="font-size:12px;font-weight:bold;margin-left:5px">Modificar usuario</span>
                                    </b-button>
                                  </b-form-group>
                                </b-col>
                                  <b-col>
                                    <b-form-group label-for="cleanform">
                                      <b-button block type="reset" name="cleanform" id="cleanform" variant="danger">
                                        <i class="fas fa-arrow-left"></i>
                                        <span class="text-uppercase" style="font-size:12px;font-weight:bold;margin-left:5px">Salir de la edicion</span>
                                      </b-button>
                                    </b-form-group>
                                  </b-col>
                              </b-row>
                            </b-col>
                        </b-row>


                        </div>
                      </b-form>
                      <!-- END FORMULARIO DE ADICION -->


                  </div><!-- END V if submitted-->

                  <div v-else>
                    <basic-circle-loader />
                  </div>
              </div>


    </b-card>
  </div>
</template>




<script>
import UserService from "@/services/UserService";
import BasicCircleLoader from "@/components/common/BasicCircleLoader"

export default {
  name: "edit-user",
  components: {
    'basic-circle-loader': BasicCircleLoader
  },
  data() {
    return {
      //selectedType es necesario aquí hasta que añadamos el tipo al modelo de datos
      //También habría que actualizar el v-model acorde para que coja el campo del modelo
      currentUser: null,
      objectRoleList: [],
      roleList: [],
      selectedRole: "",
      password: "",
      passwordcheck: "",
      submitted: false,
      disabledInput: false
    };
  },
  mounted() {
    //Cargamos la lista
    this.retrieveRoles();
  },
  methods: {
    retrieveRoles() {
      UserService.getAllRoles()
        .then(response => {
          this.objectRoleList = response.data;

          for(var i = 0; i < this.objectRoleList.length; i++) {
            var obj = this.objectRoleList[i];
            this.roleList.push(obj.alias);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },

    getUser(iduser) {
      //Delay de carga
      this.loadDelay()
      //Get device data
      UserService.get(iduser)
        .then(response => {
          this.currentUser = response.data.user
          this.selectedRole = (this.currentUser.role) ? this.currentUser.role.alias : "null";
        })
        .catch(e => {
          console.log("Error en getUser");
          console.log(e);
        });
    },

    updateUser(e) {
      //Prevent submit
      e.preventDefault()
      //Disable buttons before re-enabled
      this.disabledInput = true;
      //Update the sensor
      this.fillRoleData(this.actualUpdate);
    },

    fillRoleData(callback) {
      if (this.selectedRole && this.selectedRole != "null") {
        let selectedRoleObject = this.objectRoleList.filter((item) => {return item.alias == this.selectedRole})
        this.currentUser.role = selectedRoleObject[0];
        callback();
      } else {
        this.currentUser.role = null;
        callback();
      }
    },

    actualUpdate() {
      var passCorrect = false;

      if (!this.password) {
        this.currentUser.password = null;
        passCorrect = true;
      } else {
        if (this.password === this.passwordcheck && this.password.length > 5) {
          this.currentUser.password = this.password;
          passCorrect = true;
        } else {
          passCorrect = false;
        }
      }

      if (passCorrect){
        UserService.update(this.currentUser)
          .then(response => {
            this.getUser(this.currentUser._id)
            //Mensaje de actualización
            this.$notify({
               group: 'notificateDiv',
               type: 'success',
               title: response.data.message ? response.data.message : 'Usuario modificado correctamente',
               text: response.data.message ? "" : 'Se ha modificado el usuario seleccionado',
               duration: 3000,
               speed: 1000
            });
            //delay antes de rehabilitarlos
            setTimeout(()=>{
              //Avisamos al parent de que cambie componente
              this.disabledInput = false;
            },500);
            //Refresh table list (parent signal)
            this.$emit('refreshlist')

          })
          .catch(e => {
            console.log(e);
            //Mensaje de actualización
            this.$notify({
               group: 'notificateDiv',
               type: 'pepito',
               title: 'Error al guardar los cambios',
               text: 'No se han podido almacenar los cambios solicitados',
               duration: 3000,
               speed: 1000
            });
          });
        } else {
          this.$notify({
             group: 'notificateDiv',
             type: 'pepito',
             title: 'Error al guardar los cambios',
             text: 'Las contraseñas no coinciden o son demasiado cortas',
             duration: 3000,
             speed: 1000
          });
        }
       //Rehabilitiamso lso botones de nuevo
       this.disabledInput = false;
    },

    loadDelay(){
      //Cargamos el div oculto
      this.submitted = true;
      //Timeout para cambiar de pagina
      setTimeout(()=>{
        //Cambiamos de div
        this.submitted = false
      },500);
    },

    exitForm() {
      //Delay de carga
      this.loadDelay()
      setTimeout(()=>{
        //Avisamos al parent de que cambie componente
        this.$emit('editexit')
      },500);
    }
  }
  
};
</script>

<style scoped>
.groupBox{
  border: 1px solid rgba(0,0,0,.0625);
  border-radius:3px;
  padding:30px;
  margin-left:30px;
  margin-right:30px;
}

.innergroupBox{
  border: 1px solid rgba(0,0,0,.0625);
  border-radius:3px;
  padding: 20px;
}
</style>
